import React, { useEffect, useState } from "react";
import { StyleSheet, Text, Switch, View, Platform } from "react-native";

import appStyles from "../../../../appStyles";
import AppTheme from "../../../AppTheme";


export default function Channel({ item, onToggle = () => {} }) {
  const [isSelected, setIsSelected] = useState(item.isSelected);

  useEffect(() => {
    setIsSelected(item.isSelected);
  }, [item.isSelected]);

  const toggleCalendar = (value) => {
    setIsSelected(value);
    onToggle(item, value);
  };

  return (
    <View style={[styles.calendarItem, appStyles.borderBottom]}>
      <Text style={styles.calendarItemName}>{item.name}</Text>

      <Switch
        value={isSelected}
        thumbColor="#FFF"
        trackColor={{
          true: "#239c9d",
          false: "#f3f2f1",
        }}
        onValueChange={toggleCalendar}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  calendarItem: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    height: 40,
  },
  calendarItemName: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    flex: 1,
  },
});
